module.exports = __webpack_public_path__ + "media/images/share-play-ae4e9c3b85763a86cccc26394c5510dd.svg";